import { createApp } from 'vue';
import UploadComponent from '../components/uploadArtwork/UploadComponent';

function uploadApp(opts) {
  const config = {
    dom: {
      parent: 'uploadApp',
    },
  };

  const c = __.extend(config, opts);

  // Globals
  const $parent = document.getElementById(c.dom.parent);
  function init() {
    if (!$parent) return;

    const app = createApp(UploadComponent);

    app.mount(`#${c.dom.parent}`);
  }

  init();
}

export default uploadApp;
